module.exports = __webpack_public_path__ + "media/images/carrusel/delegaciones11-57d9efa9a2b4c2062928fd63b0854efb.jpg";